export default __webpack_public_path__ + "static/media/patrice-2.a31bc400.png";